import React from 'react'
import biote_lapis1 from '../../images/biote_lapis1.png'

import biote_lapis2 from '../../images/biote_lapis2.png'

const First_pane = () => {
  return (
    <div className=''>
           <div
        
        style={{ 
        backgroundImage: `-webkit-linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${biote_lapis1})`,
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${biote_lapis1})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingBottom: '50px',
        paddingTop: '100px',
        height: '120vh'
        }}
    
    
    >


        <div className='uk-container'>

            <div className='uk-grid' data-uk-grid>
                <div className='uk-width-3-4@s'>
                    
           <h1 className='light header1 uk-margin-xlarge-top' uk-scrollspy="cls: uk-animation-slide-right; repeat: true">Biote Lapis II Residence    </h1>
      
           <h5 className='light uk-margin-medium-top'
            uk-scrollspy="cls: uk-animation-fade; repeat: true">
              
Plot Number: Plot 1022, Cad zone B10, Daki biu (Jabi) District              
Plot Title:    Certificate of Occupancy <br/>
Plot Size:    1,436.12 M <br/>
Land Use:    Residential<br/>
Mode of Land Acquisition:     Joint Venture<br/>
Total No. Of Housing Units:    6 uNITS<br/>
Project Start Date:    April 2025<br/>


              
              </h5>
                </div>

                <div className='uk-width-1-4@s'>

                </div>
            </div>

    




        </div>
       
    </div>



     <div className='uk-container uk-text-center uk-margin-large-top' >
         <h3>The Promise</h3>
        <div className='uk-width-1-1'>
            <img src={biote_lapis1} />
        </div>
      </div>



        <div className='uk-container uk-text-center uk-margin-large-top' >
         <h3>Ongoing Project</h3>
        <div className='uk-width-1-1'>
            <img src={biote_lapis2} />
        </div>
      </div>




 

  
      




    </div>
  )
}

export default First_pane